import { Page_Workspace } from './Page_Workspace.js';
import { ModuleFE_WorkHub } from '@nu-art/work-hub-frontend/modules';
import { RoutePermissions } from '@nu-art/permissions-frontend';
export const RouteKey_Workspace = 'workspace';
export const Route_Workspace = {
    key: RouteKey_Workspace,
    Component: Page_Workspace,
    path: 'workspace',
    enabled: RoutePermissions(ModuleFE_WorkHub.permissions.Release),
};
